import dayjs from 'dayjs';
import { FC, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimer } from 'react-timer-hook';
import { Button, Color } from 'shared/components/Button/Button';

interface ResendButtonProps {
  onOtpResend: () => Promise<string>;
  loading?: boolean;
  className?: string;
  color?: Color;
}

export const ResendButton: FC<ResendButtonProps> = memo(
  ({ onOtpResend, color = 'primary', loading = false }) => {
    const { t } = useTranslation();
    const { seconds, isRunning, restart } = useTimer({
      autoStart: true,
      expiryTimestamp: dayjs().add(59, 'seconds').toDate(),
    });

    const handleResendOtp = useCallback(async () => {
      await onOtpResend();
      restart(dayjs().add(59, 'seconds').toDate());
    }, []);

    return isRunning ? (
      <p className="font-medium">
        {t('auth:resendOtpTimer', {
          seconds,
        })}
      </p>
    ) : (
      <Button
        disabled={loading}
        size="md"
        name="resendOtpButton"
        variant="text"
        color={color}
        onClick={handleResendOtp}
      >
        {t('auth:resendOtp')}
      </Button>
    );
  },
);
